/**
 *  App Switcher
 */

export {}

// Determine which app to load
const isLandingMode: boolean =
  window.location.pathname === '/installment-promotion'

console.log(`🚀 Loading ${isLandingMode ? 'Landing' : 'Checkout'} App`)

// loading function
const loadApp = async (): Promise<void> => {
  try {
    if (isLandingMode) {
      // Load landing app
      await import('./landing')
      console.log('✅ Landing app loaded')
    } else {
      // Load checkout app
      await import('./checkout')
      console.log('✅ Checkout app loaded')
    }
  } catch (error) {
    console.error('❌ Failed to load app:', error)

    // Show error message
    const root = document.getElementById('root')
    if (root) {
      root.innerHTML = `
        <div style="display: flex align-items: center justify-content: center height: 100vh font-family: sans-serif">
          <div style="text-align: center">
            <h1 style="color: #dc3545">App Loading Failed</h1>
            <p style="color: #666">Please refresh the page to try again.</p>
            <button onclick="window.location.reload()" style="
              background: #007bff color: white border: none padding: 12px 24px
              border-radius: 4px cursor: pointer font-size: 16px
            ">Refresh Page</button>
          </div>
        </div>
      `
    }
  }
}

// Initialize
void loadApp()
